import React from 'react';
import {connect} from 'react-redux';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import {pushEdapEvent} from '../../../utils/edap';

function breadcrumbClickHandler(breadcrumbs) {
    if (breadcrumbs.length === 0) {
        return () => {};
    }

    return (event, crumb) => {
        const isHome = breadcrumbs.indexOf(crumb) === 0;

        const edapData = {
            actionlocation: 'destination-breadcrumb',
            eventlbsuuid: isHome ? '-1' : crumb.lbsId
        };

        const eventrefinements = crumb.types.join(',');

        if (eventrefinements.length > 0) {
            edapData.eventrefinements = eventrefinements;
        }

        pushEdapEvent('destination.link.click', edapData);
    };
}

export const BreadcrumbsComponent = (props) => {
    const {breadcrumbs} = props;

    return (
        <Breadcrumbs
            crumbs={breadcrumbs}
            className="breadcrumbs container"
            onClickCrumbName={breadcrumbClickHandler(breadcrumbs)}
        />
    );
};

export function mapStateToProps(state) {
    return {
        breadcrumbs: state.destination.details.breadcrumbs
    };
}

export const BreadCrumbs = connect(mapStateToProps)(BreadcrumbsComponent);
